/*
 * Copyright (c) 2025 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, March 26th 2025, 8:37:31 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Typography from "@mui/material/Typography";
import { truncate } from "lodash";
import { APIMany2ManyFormInput, ConcreteAPIMany2ManyInputProps } from "ui-widgets";
import { APISERVICEPATHS } from "lib/api";
import { ContentTag } from "lib/schemas";
import { useGetScreenProperties } from "lib/utils";
import ListItemText from "@mui/material/ListItemText";
import { RGBTriplets } from "theme/styles";

export const GeneralContentTagsMany2ManyPicker = <T,>(props: ConcreteAPIMany2ManyInputProps<T, ContentTag>) => {
  const screenProperties = useGetScreenProperties();
  let truncateSize = 0;
  switch (screenProperties.deviceTypeGuess) {
    case "desktop":
      truncateSize = 16;
      break;
    case "tablet":
      truncateSize = 16;
      break;
    case "mobile":
      truncateSize = 28;
      break;
    case "4kTV":
      truncateSize = 0;
      break;
    default:
      truncateSize = 0;
  }

  return (
    <APIMany2ManyFormInput<T, ContentTag>
      apiServicePath={APISERVICEPATHS.contentTags}
      apiQueryParams={{ all_tags: true, type: "portal" }}
      filterByGlobalOrganization={false}
      itemIdProperty="id"
      getOptionComponent={(option) => <ListItemText primary={option.name} />}
      {...props}
    >
      {({ filteredItems, selectedItemIds, onCheckItem }) => (
        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ overflow: "auto" }}>
          {filteredItems
            .sort((a, b) => (a.name < b.name ? -1 : 1))
            .map((item, index) => {
              return (
                <Grid item xs={4} sm={4} md={4} key={index}>
                  <Tooltip title={<Typography>{item.name}</Typography>}>
                    <Chip
                      sx={{
                        backgroundColor: selectedItemIds.includes(item.id)
                          ? `rgba(${RGBTriplets.primary}, 10%)`
                          : "#ffffff",
                        borderColor: "var(--grey-01)",
                        borderStyle: "groove",
                        borderWidth: "1px",
                      }}
                      onClick={() => onCheckItem(item.id)}
                      icon={
                        <IconButton size="small">
                          {selectedItemIds.includes(item.id) ? (
                            <CheckBoxIcon fontSize="small" color="primary" />
                          ) : (
                            <CheckBoxOutlineBlankIcon fontSize="small" color="primary" />
                          )}
                        </IconButton>
                      }
                      label={
                        <Typography variant="body1">
                          {truncateSize ? truncate(item.name, { length: truncateSize, omission: "..." }) : item.name}
                        </Typography>
                      }
                    />
                  </Tooltip>
                </Grid>
              );
            })}
        </Grid>
      )}
    </APIMany2ManyFormInput>
  );
};
